import { render, staticRenderFns } from "./logo.vue?vue&type=template&id=4b7815a3&scoped=true"
import script from "./logo.vue?vue&type=script&lang=ts"
export * from "./logo.vue?vue&type=script&lang=ts"
import style0 from "./logo.vue?vue&type=style&index=0&id=4b7815a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7815a3",
  null
  
)

export default component.exports